export default __webpack_public_path__ + "static/media/72.bf397c6d.jpg";